import { createEffects } from '@angular-architects/ngrx-toolkit';
import { map } from 'rxjs';
import { appActions } from './app.action';
import { APP_STORE_INITIAL_STATE } from './app.state';

export const appEffects = createEffects(appActions, (actions, create) => {
    // const tod = inject(TranslationService);
    return {
        // initializeTranslations$: create(actions.initializeTranslations).pipe(
        //     tap(({lang}) => { actions.setLanguageSelected({ value: lang })}),
        //     switchMap(({lang}) => tod.getLabels(lang).pipe(map((i18n) => actions.setTranslations({ value: i18n as typeof APP_DEFAULTS.i18n }))),),
        // ),
        reset$: create(actions.reset).pipe(
            map(() =>
                actions.restAll({
                    ...APP_STORE_INITIAL_STATE,
                }),
            ),
        ),
    };
});
